<template>
    <MDBRow>
        <MDBCol xs="12">
            <div class="fw-bold">{{ $t('multiplicator.title') }}</div>
            <div class="pb-2">{{ $t('multiplicator.selectTarget', { year: currentYear }) }}</div>
            <MDBTable borderless v-if="bonusMultiplicator.length > 0" class="points-overview px-1">
                <thead>
                    <th width="300">&nbsp;</th>
                    <th v-for="(bonus, index) in bonusMultiplicator" :key="index"
                        :class="{ 'is-selected': isSelected(bonus.id) }" class="cursor--pointer"
                        @click="storeUserGoal(bonus.id)">
                        <div class="fw-bold">{{ $t(`multiplicator.goals.${bonus.name}`) }}</div>
                    </th>
                </thead>
                <tbody>
                    <tr>
                        <td class="fw-bold">{{ $t('tyreBox.minimum') }}</td>
                        <td colspan="5" class="text-center" v-html="$t('multiplicator.minTyres', {
                            tyre: shopLimit?.limit
                        })"></td>
                    </tr>
                    <tr>
                        <td class="fw-bold">{{ $t('multiplicator.amountLabel') }}</td>
                        <td v-for="(bonus, index1) in bonusMultiplicator" :key="index1" @click="storeUserGoal(bonus.id)"
                            :class="{ 'is-selected': isSelected(bonus.id) }" class="cursor--pointer">{{
                                bonus.min_tyres }} - {{
                                bonus.show_max ? bonus.max_tyres : $t('multiplicator.andMore')
                            }}
                        </td>
                    </tr>
                    <tr>
                        <td class="fw-bold">{{ $t('multiplicator.label') }}</td>
                        <td v-for="(bonus, index2) in bonusMultiplicator" :key="index2"
                            :class="{ 'is-selected': isSelected(bonus.id) }" class="cursor--pointer">x
                            {{
                                bonus.factor }}
                        </td>
                    </tr>
                    <tr>
                        <td colspan="6" class="fw-bold">
                            {{ $t('multiplicator.bandBonusTitle') }}
                        </td>
                    </tr>
                    <tr>
                        <td>PC4 Bridgestone 14"-16"</td>
                        <td>1,00 &euro;</td>
                        <td>1,25 &euro;</td>
                        <td>1,50 &euro;</td>
                        <td>1,75 &euro;</td>
                        <td>2,00 &euro;</td>
                    </tr>
                    <tr>
                        <td>PC4 Bridgestone 17"-18"</td>
                        <td>2,00 &euro;</td>
                        <td>2,50 &euro;</td>
                        <td>3,00 &euro;</td>
                        <td>3,50 &euro;</td>
                        <td>4,00 &euro;</td>
                    </tr>
                    <tr>
                        <td>PC4 Bridgestone 19"-22"</td>
                        <td>4,00 &euro;</td>
                        <td>5,00 &euro;</td>
                        <td>6,00 &euro;</td>
                        <td>7,00 &euro;</td>
                        <td>8,00 &euro;</td>
                    </tr>
                </tbody>
            </MDBTable>
            <div>(*) {{ $t('multiplicator.desc') }}</div>
        </MDBCol>
    </MDBRow>
</template>

<script setup>
import { MDBCol, MDBRow, MDBTable } from "mdb-vue-ui-kit";
import { ProfileService } from "@/services/profile.service";
import { useStore } from "vuex";
import { computed, ref, watch } from "vue";

const store = useStore();
const currentYear = new Date().getFullYear();

const user = computed(() => store.getters.getMe);
const bonusMultiplicator = computed(() => store.getters.getBonusMultiplicator);
const shopLimit = computed(() => store.getters.getTyreLimit);
const selectedBonusId = ref(null);

watch(
    () => user.value?.bonus_multiplicator_id,
    (nextId) => {
        selectedBonusId.value = nextId == null ? null : Number(nextId);
    },
    { immediate: true }
);

const isSelected = (bonusId) => Number(bonusId) === selectedBonusId.value;

const storeUserGoal = async (bonus_multiplicator_id) => {
    const previous = selectedBonusId.value;
    selectedBonusId.value = Number(bonus_multiplicator_id);

    try {
        const data = {
            user_id: user.value.plainId,
            bonus_multiplicator_id,
        };

        await ProfileService.setTyreGoal(data);
        await store.dispatch("me");
    } catch (e) {
        selectedBonusId.value = previous;
        console.error(e);
    }
};
</script>

<style lang="scss" scoped>
@import "@/styles/KickbackFeeMultiplicatorInfo.scss";
</style>
